import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { captureBootstrapError, initSentry } from '@hosty-app/services';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Before bootstrap, so a bootstrap failure (which the user sees as an app that
// never starts) is reported rather than lost to the device console.
initSentry();

const onReady = (): void => {
  if (environment.isMobile && window['Keyboard']) {
    window['Keyboard'].shrinkView?.(true);
    window['Keyboard'].hideFormAccessoryBar?.(true);
  }
  bootstrapApplication(AppComponent, appConfig).catch((err) => {
    console.error(err);
    captureBootstrapError(err);
  });
};

if (environment.isMobile) {
  const script = document.createElement('script');
  script.src = 'cordova.js';
  script.type = 'text/javascript';
  document.head.append(script);
  document.addEventListener('deviceready', onReady, false);
} else {
  onReady();
}
